
import { supabase } from "@/integrations/supabase/client";

export const profileInteractionService = {
  async sendBuzzz(currentUserId: string, targetUserId: string) {
    const { error } = await supabase
      .from('interactions')
      .insert({
        user_id: currentUserId,
        target_user_id: targetUserId,
        interaction_type: 'buzzz'
      });

    if (error) throw error;
  },

  async reportUser(reporterId: string, reportedId: string, reason: string) {
    const { error } = await supabase
      .from('user_reports')
      .insert({
        reporter_id: reporterId,
        reported_id: reportedId,
        reason: reason,
        description: "Report from profile modal"
      });

    if (error) throw error;
  },

  async addFavorite(currentUserId: string, favoriteUserId: string) {
    const { error } = await supabase
      .from('user_favorites')
      .insert({
        user_id: currentUserId,
        favorite_user_id: favoriteUserId
      });

    if (error) throw error;
  },

  async removeFavorite(currentUserId: string, favoriteUserId: string) {
    const { error } = await supabase
      .from('user_favorites')
      .delete()
      .eq('user_id', currentUserId)
      .eq('favorite_user_id', favoriteUserId);

    if (error) throw error;
  },

  async isFavorite(currentUserId: string, favoriteUserId: string) {
    const { data, error } = await supabase
      .from('user_favorites')
      .select('id')
      .eq('user_id', currentUserId)
      .eq('favorite_user_id', favoriteUserId)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return !!data;
  }
};
